import { ContentTitle } from "@/shared/components/layout/titleContentLayout";
import { SelectChangeEvent } from "@mui/material";
import { useState } from "react";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import Content from "./content";
import CardBoxLayout from "@/modules/merchant/layout/cardBoxLayout";
/**
 * ReputableStore
 *
 * مدیریت و نمایش اعتبارهای فروشگاهی مشتری با امکان انتخاب موجودی کیف پول و فیلترهای مرتبط.
 *
 * @remarks
 * - از useState برای مدیریت مقدار انتخاب شده در منوی بالای صفحه استفاده می‌کند.
 * - `ContentTitle` برای نمایش عنوان "اعتبارات فروشگاهی" و کنترل انتخاب موجودی و فیلترها استفاده می‌شود.
 * - `CardBoxLayout` برای نمایش محتوا با استایل و پس‌زمینه گرادیان استفاده شده است.
 * - کامپوننت `Content` لیست اعتبارهای فروشگاهی را نمایش می‌دهد.
 *
 * @returns JSX.Element
 * کامپوننتی که جدول اعتبارهای فروشگاهی و فیلترهای مرتبط را نمایش می‌دهد.
 */
const ReputableStore = () => {
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");
  const menuOptions = [
    { value: "option1", label: "موجودی نقدی : 5,000,000 ریال" },
    { value: "option2", label: "گزینه دوم" },
    { value: "option3", label: "گزینه سوم" },
    { value: "option4", label: "گزینه چهارم" },
    { value: "option5", label: "گزینه پنجم" },
  ];

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };
  return (
    <>
      <ContentTitle handleChange={handleChange} icon={<StorefrontOutlinedIcon />} labelInput="انتخاب گزینه" value={value} setValue={setValue} title="اعتبارات فروشگاهی" options={menuOptions}/>
      <CardBoxLayout sx={{background: "linear-gradient(97.77deg, rgba(255, 255, 255, 1) -9.73%, rgba(255, 255, 255, 1) 109.42%)"}}>
        <Content />
      </CardBoxLayout>
    </>
  );
};

export default ReputableStore;
